import { Component, OnInit , Input} from '@angular/core';
import { NgClass } from '@angular/common';
import { DirectivesModule } from 'src/app/directives.module';

@Component({
    selector: 'app-validated-dict',
    templateUrl: './validated-dict.component.html',
    styleUrls: ['./validated-dict.component.scss'],
    
    standalone: true,
    imports: [NgClass, DirectivesModule]
})
export class ValidatedDictComponent implements OnInit {
@Input() validateDict: any;
@Input() from: any;
  constructor() { }

  ngOnInit(): void {
  }

}
